<script>
export default {
  name: 'SideRight',
}
</script>

<template>
  <div class="side-right">
    <div class="thumb-qr-text">
      <img src="@/assets/images/home-page/pc/qr_text.png" />
    </div>
    <div class="thumb-pr">
      <img src="@/assets/images/home-page/pc/qr_img.png" />
    </div>
  </div>
  
</template>

<style lang="scss" scoped>
  @import 'side-right.scss';
</style>
